import { SingleDatePicker } from 'react-dates';
import { ContentDate, DateLabel, StyledCalendarIcon } from '../styles';

type Props = {
  label: string;
  date: moment.Moment | null;
  onDateChange: (date: moment.Moment | null) => void;
  focused: boolean;
  onFocusChange: (arg: { focused: boolean }) => void;
  id: string;
  isOutsideRange?: (day: moment.Moment) => boolean;
  disabled?: boolean;
};

export const DateInputWrapper = ({
  label,
  date,
  onDateChange,
  focused,
  onFocusChange,
  id,
  isOutsideRange,
  disabled = false,
}: Props): JSX.Element => (
  <ContentDate>
    <DateLabel>{label}</DateLabel>
    <br />
    <SingleDatePicker
      disabled={disabled}
      date={date}
      onDateChange={onDateChange}
      focused={focused}
      onFocusChange={onFocusChange}
      id={id}
      numberOfMonths={1}
      isOutsideRange={isOutsideRange}
      placeholder="dd/mm/aaaa"
      displayFormat="DD/MM/YYYY"
    />
    <StyledCalendarIcon />
  </ContentDate>
);
